import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import SpeakButton from '../../common/SpeakButton/SpeakButton';
import useFitText from '../../hooks/useFitText';
import './test-question.scss';

/** Питання будь-якого тесту: від 44px вниз до звичайного розміру, далі — перенос рядка. */
const QUESTION_MAX = 44;
const QUESTION_MIN_MOBILE = 16;
const QUESTION_MIN_TABLET = 18;

const TestQuestion = ({ title, question, image, emoji, videoLink, conformity, lang }) => {
  const questionRef = useRef(null);
  const questionMin = typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches
    ? QUESTION_MIN_TABLET
    : QUESTION_MIN_MOBILE;

  useFitText(questionRef, question, { max: QUESTION_MAX, min: questionMin, enabled: Boolean(question) });

  return (
    <div className={`test-question ${conformity ? 'test-question--sm' : ''}`}>
      {videoLink && (
        <div className="video-wrapper" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, marginBottom: '20px', borderRadius: '6px' }}>
          <iframe
            src={videoLink}
            title="Відео пояснення"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      )
      }
      {title && <div className="test-question__title">{title}</div>}
      {image && (
        <div className="test-question__pic" key={image}>
          <img src={image} alt="" draggable="false" onError={(event) => { event.currentTarget.parentElement.hidden = true; }} />
        </div>
      )}
      {!image && emoji && (
        <div className="test-question__pic test-question__pic--emoji" key={emoji}>
          <span className="test-question__emoji" aria-hidden="true">{emoji}</span>
        </div>
      )}
      {question && (
        <div className="test-question__word">
          <div className="test-question__word-row">
            <span className="test-question__word-text" ref={questionRef}>{question}</span>
            <SpeakButton text={question} lang={lang} size="md" className="test-question__speak" />
          </div>
          <div className="test-question__word-bar" />
        </div>
      )}

    </div>
  );
};

TestQuestion.propTypes = {
  title: PropTypes.string,
  question: PropTypes.string,
  image: PropTypes.string,
  emoji: PropTypes.string,
  videoLink: PropTypes.string,
  conformity: PropTypes.bool,
  lang: PropTypes.string
};

export default TestQuestion;